var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rel w-6 h-8 cursor-pointer",on:{"click":_vm.click}},[_c('canvas',{ref:"canvas",staticClass:"wh-full"}),(!_vm.selected)?_c('div',{staticClass:"abs-full bg-black opacity-0.5"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }